import { defineStore } from 'pinia';

interface PageState {
  routeData: any;
  pageData: any;
}

export const usePageStore = defineStore('page', {
  state: (): PageState => ({
    routeData: null,
    pageData: null,
  }),
});
